import { useState } from 'react';
import { supabase } from './storage';

const T = {
  bg: "#0F0F13", card: "#1A1A22", border: "#2A2A36", text: "#C8C8D4",
  muted: "#6B6B80", head: "#F0F0F5", pink: "#E91E90", pinkG: "rgba(233,30,144,0.12)",
  inp: "#15151D", red: "#EF4444",
};

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError('Udfyld email og password'); return; }

    if (!supabase) {
      setError('Supabase er ikke konfigureret. Tjek miljøvariablerne REACT_APP_SUPABASE_URL og REACT_APP_SUPABASE_ANON_KEY i Vercel.');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const { data, error: err } = await supabase.auth.signInWithPassword({ email, password });
      if (err) {
        setError('Forkert email eller password');
      } else if (data?.user) {
        onLogin(data.user);
      } else {
        setError('Ukendt fejl – prøv igen');
      }
    } catch (ex) {
      setError('Forbindelsesfejl – tjek din internetforbindelse');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', background: T.bg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: 20,
      fontFamily: "'Outfit', sans-serif",
    }}>
      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&display=swap" rel="stylesheet"/>
      <div style={{
        background: T.card, borderRadius: 20, padding: '48px 36px',
        width: '100%', maxWidth: 420, border: `1px solid ${T.border}`,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <img src="/logo.png" alt="Anka Media" style={{
            width: 80, height: 80, borderRadius: 16, marginBottom: 20,
          }}/>
          <h1 style={{ fontSize: 28, fontWeight: 800, margin: 0, color: T.head }}>
            ANKA <span style={{ color: T.pink }}>CRM</span>
          </h1>
          <p style={{ fontSize: 15, color: T.muted, margin: '6px 0 0' }}>
            Log ind for at fortsætte
          </p>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 20 }}>
            <label style={{
              fontSize: 13, fontWeight: 600, color: T.muted, display: 'block',
              marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em',
            }}>Email</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="din@email.dk" autoComplete="email"
              style={{
                width: '100%', padding: '14px 16px', borderRadius: 12,
                border: `1px solid ${T.border}`, fontSize: 16,
                background: T.inp, color: T.head, outline: 'none', boxSizing: 'border-box',
              }}
            />
          </div>

          <div style={{ marginBottom: 28 }}>
            <label style={{
              fontSize: 13, fontWeight: 600, color: T.muted, display: 'block',
              marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em',
            }}>Password</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" autoComplete="current-password"
              style={{
                width: '100%', padding: '14px 16px', borderRadius: 12,
                border: `1px solid ${T.border}`, fontSize: 16,
                background: T.inp, color: T.head, outline: 'none', boxSizing: 'border-box',
              }}
            />
          </div>

          {error && (
            <div style={{
              background: `${T.red}15`, border: `1px solid ${T.red}30`,
              borderRadius: 10, padding: '10px 14px', marginBottom: 20,
              fontSize: 14, color: T.red, textAlign: 'center', lineHeight: 1.4,
            }}>
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '16px', borderRadius: 12,
            background: T.pink, color: '#fff', border: 'none',
            fontSize: 17, fontWeight: 700, cursor: loading ? 'wait' : 'pointer',
            opacity: loading ? 0.7 : 1,
          }}>
            {loading ? 'Logger ind...' : 'Log ind'}
          </button>
        </form>
      </div>

      <style>{`
        input:focus { border-color: ${T.pink} !important; box-shadow: 0 0 0 3px ${T.pinkG} !important; }
        * { box-sizing: border-box; }
      `}</style>
    </div>
  );
}
